import { useState } from "react";
import "./style.scss";

export default function Card({ children, style = {}, onClick, hover }) {
  const [hov, setHov] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      className={`compCard${hov && hover ? " is-hovered" : ""}`}
      style={{ ...style }}
    >
      {children}
    </div>
  );
}
